module.exports = __webpack_public_path__ + "img/gb9113_24.prt.2f2be047.jpg";